export default __webpack_public_path__ + "cb9e36f02dcdf96f6a729b828e727683.webp";